<template>
  <div class="service-add-page">
    <!-- 当前时间 / 当前定位 -->
    <div class="info-card">
      <div class="info-row"><span class="info-label">当前时间：</span><span class="info-value">{{ currentTime }}</span></div>
      <div class="info-row"><span class="info-label">当前定位：</span><span class="info-value">{{ currentLocation }}</span></div>
    </div>

    <!-- 服务现场照片 -->
    <div class="section-card">
      <div class="section-header">
        <span class="section-title">服务现场照片<span class="section-tip">（最多允许上传3张图）</span></span>
      </div>
      <!-- 上传按钮与预览区：位于标题下方 -->
      <van-uploader class="service-uploader" v-model="photoList" accept="image/*" :max-count="3" :after-read="afterReadPhoto">
        <van-button class="upload-btn" plain type="info" size="small">+ 上传现场照片</van-button>
      </van-uploader>
    </div>

    <!-- 服务说明（多行文本，最多500字） -->
    <div class="section-card">
      <div class="section-title">服务说明</div>
      <van-field
        v-model="serviceDesc"
        type="textarea"
        rows="5"
        autosize
        :maxlength="500"
        show-word-limit
        class="desc-field"
        placeholder="请输入服务说明"
      />
    </div>

    <!-- 服务成果 -->
    <div class="section-card">
      <div class="section-header">
        <span class="section-title">服务成果<span class="section-tip">（允许上传 doc、docx、pdf格式）</span></span>
      </div>
      <!-- 上传按钮与预览区：位于标题下方 -->
      <van-uploader class="service-uploader" v-model="resultList" accept=".pdf,.doc,.docx" :after-read="afterReadResult">
        <van-button class="upload-btn" plain type="info" size="small">+ 上传服务成果附件</van-button>
      </van-uploader>
    </div>

    <!-- 底部操作按钮：左侧返回（灰色描边），右侧保存（红色） -->
    <div class="save-row">
      <van-button class="btn-cancel" plain @click="backPageInfo">
        返回
      </van-button>
      <van-button class="signup-btn" round @click="onSave">保存</van-button>
    </div>
  </div>
</template>
<script>
import { NavBar } from 'vant'
import wx from 'weixin-js-sdk'
import requestHomeAPI from '@/axios/HomeApi'
import requestHTAPI from '@/axios/HantangTax'

export default {
  name: 'ServiceRecordAdd',
  components: {
    [NavBar.name]: NavBar
  },
  data () {
    return {
      // 当前时间（每秒更新）
      currentTime: '',
      timer: null,
      // 当前定位信息
      currentLocation: '定位中...',
      longitude: '', // 经度
      latitude: '', // 纬度
      locaction: '', // 服务地址（由 getServiceLocation 接口按经纬度逆解析填充）
      // 任务信息（来自我的任务列表跳转）
      form: {
        merId: '',
        projectId: '',
        registPersonId: '',
        projectName: '',
        merName: ''
      },
      // 服务现场照片列表
      photoList: [],
      // 服务成果附件列表
      resultList: [],
      // 服务说明（预设演示数据）
      serviceDesc: ''
    }
  },
  created () {
    // 接收任务信息（来自我的任务列表跳转）
    const query = this.$route.query || {}
    this.form.merId = query.merId || ''
    this.form.projectId = query.projectId || ''
    this.form.registPersonId = query.registPersonId || ''
    this.form.projectName = query.projectName || ''
    this.form.merName = query.merName || ''
    // 每秒更新当前时间
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
    // 获取当前位置
    this.getLocation()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 格式化时间：2026-08-14 12:21:22
    formatTime (date) {
      const pad = num => (num < 10 ? '0' + num : '' + num)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    updateTime () {
      this.currentTime = this.formatTime(new Date())
    },
    // 获取当前位置：正式环境用微信 JS-SDK 定位，开发环境用浏览器定位
    getLocation () {
      if (process.env.NODE_ENV === 'development') {
        this.fallbackGeolocation()
        return
      }
      this.getJsSDK()
    },
    // 微信 JS-SDK 签名注入（后端 jsJdk2 接口，需公众号开通「获取地理位置」权限）
    getJsSDK () {
      // 解决 iOS 客户端在 history 模式下签名失败问题
      let url = ''
      if (window.__wxjs_is_wkwebview === true) {
        url = window.entryUrl.split('#')[0]
      } else {
        url = window.location.href.split('#')[0]
      }
      const formData = new FormData()
      const data = { url }
      for (const key in data) {
        formData.append(key, data[key])
      }
      requestHTAPI.jsJdk2(formData).then(res => {
        if (res.data.code === '0000') {
          const { data } = res.data
          wx.config({
            debug: false,
            appId: process.env.VUE_APP_BASE_APPID,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['getLocation']
          })
          wx.ready(() => {
            this.wxGetLocation()
          })
          wx.error(err => {
            console.log('JSSDK 配置失败', err)
            this.fallbackGeolocation()
          })
        } else {
          this.fallbackGeolocation()
        }
      }).catch(() => {
        this.fallbackGeolocation()
      })
    },
    // 微信定位（gcj02 国内坐标）
    wxGetLocation () {
      wx.getLocation({
        type: 'gcj02',
        success: res => {
          this.longitude = String(res.longitude)
          this.latitude = String(res.latitude)
          this.currentLocation = `经度 ${this.longitude}，纬度 ${this.latitude}`
          // 经纬度逆解析为文字定位地址
          this.reverseGeocode()
        },
        fail: err => {
          console.log('微信定位失败', err)
          this.fallbackGeolocation()
        }
      })
    },
    // 浏览器定位兜底
    fallbackGeolocation () {
      if (!navigator.geolocation) {
        this.useMockLocation()
        return
      }
      navigator.geolocation.getCurrentPosition(
        position => {
          const { longitude, latitude } = position.coords
          this.longitude = String(longitude)
          this.latitude = String(latitude)
          this.currentLocation = `经度 ${this.longitude}，纬度 ${this.latitude}`
          // 经纬度逆解析为文字定位地址
          this.reverseGeocode()
        },
        () => {
          // 定位失败时使用模拟坐标，保证保存接口可调通
          this.useMockLocation()
        },
        {
          enableHighAccuracy: true,
          timeout: 10000
        }
      )
    },
    // 模拟定位（北京海淀区），待微信定位调试通过后移除
    useMockLocation () {
      this.longitude = '116.298'
      this.latitude = '39.959'
      this.currentLocation = '北京市海淀区（模拟定位）'
      console.log('使用模拟定位：北京海淀区')
      // 模拟坐标同样走逆解析，保证保存时 locaction 有值
      this.reverseGeocode()
    },
    // 经纬度逆解析：调用 getServiceLocation 接口生成文字定位地址
    reverseGeocode () {
      if (!this.longitude || !this.latitude) {
        return
      }
      requestHomeAPI.getServiceLocation({
        longitude: this.longitude, // 经度（String，按接口文档）
        latitude: Number(this.latitude) // 纬度（Number，按接口文档）
      }).then(res => {
        if (res.data.code === '0000') {
          this.locaction = res.data.data
          // 定位展示为逆解析后的文字地址
          this.currentLocation = this.locaction
          console.log('定位地址解析成功', this.locaction)
        } else {
          this.$toast('定位地址解析失败，请重试')
        }
      }).catch(() => {
        this.$toast('定位地址解析失败，请重试')
      })
    },
    // 服务现场照片上传（上传成功后回显地址）
    afterReadPhoto (file) {
      console.log('服务现场照片文件', file)
      const rawFile = file.file
      this.$set(file, 'status', 'uploading')
      requestHomeAPI.uploadFile(rawFile).then(res => {
        if (res.data.code === '0000') {
          // 把返回地址挂到文件项上，保存时统一收集
          this.$set(file, 'filePath', res.data.data.filePath)
          this.$set(file, 'status', 'done')
          console.log('现场照片上传成功', res.data.data.filePath)
        } else {
          this.$set(file, 'status', 'failed')
          this.photoList = this.photoList.filter(item => item !== file)
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.$set(file, 'status', 'failed')
        this.photoList = this.photoList.filter(item => item !== file)
        this.$notify({ type: 'danger', message: '上传失败，请重试' })
      })
    },
    // 服务成果附件上传（仅限 doc/docx/pdf 格式，上传成功后回显地址）
    afterReadResult (file) {
      console.log('服务成果附件', file)
      const name = (file.file && file.file.name) || ''
      if (!/\.(doc|docx|pdf)$/i.test(name)) {
        // 移除非法格式文件并提示
        this.resultList = this.resultList.filter(item => item !== file)
        this.$toast('请上传doc或pdf格式的文件')
        return
      }
      this.$set(file, 'status', 'uploading')
      requestHomeAPI.uploadFile(file.file).then(res => {
        if (res.data.code === '0000') {
          this.$set(file, 'filePath', res.data.data.filePath)
          this.$set(file, 'status', 'done')
          console.log('服务成果附件上传成功', res.data.data.filePath)
        } else {
          this.$set(file, 'status', 'failed')
          this.resultList = this.resultList.filter(item => item !== file)
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.$set(file, 'status', 'failed')
        this.resultList = this.resultList.filter(item => item !== file)
        this.$notify({ type: 'danger', message: '上传失败，请重试' })
      })
    },
    // 保存：提交服务记录
    onSave () {
      // 必填校验
      if (!this.form.merId || !this.form.projectId || !this.form.registPersonId) {
        this.$toast('缺少任务信息，请从任务列表进入')
        return
      }
      if (!this.locaction) {
        this.$toast('定位地址获取中，请稍后重试')
        return
      }
      if (!this.serviceDesc.trim()) {
        this.$toast('请填写服务说明')
        return
      }
      // 收集上传成功的文件地址
      const picList = this.photoList
        .map(item => ({ filePath: item.filePath }))
        .filter(item => item.filePath)
      const fileList = this.resultList
        .map(item => ({ filePath: item.filePath }))
        .filter(item => item.filePath)

      requestHomeAPI.saveServiceRecord({
        merId: Number(this.form.merId),
        projectId: Number(this.form.projectId),
        registPersonId: Number(this.form.registPersonId),
        projectName: this.form.projectName,
        merName: this.form.merName,
        serviceTime: this.currentTime,
        longitude: this.longitude, // 经度
        latitude: this.latitude, // 纬度
        locaction: this.locaction, // 服务地址（逆地理编码后填充）
        picList, // 服务现场照片 [{ filePath }]，最多3张
        fileList, // 服务成果附件 [{ filePath }]
        content: this.serviceDesc
      }).then(res => {
        if (res.data.code === '0000') {
          this.$toast.success('保存成功，数据已提交！')
          // 保存成功跳转到服务记录页
          this.$router.push({ path: '/serviceRecord' })
        } else {
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.$notify({ type: 'danger', message: '网络异常，请重试' })
      })
    },
    backPageInfo () {
      this.$router.back(-1)
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.service-add-page {
  min-height: 100%;
  padding-bottom: 60px;
  background: #f5f5f5;
}

/* 时间/定位信息 */
.info-card {
  margin: 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  text-align: left;

  .info-row {
    font-size: 30px;
    color: #323233;
    line-height: 45px; /* 1.5 倍行高 */
  }

  .info-label {
    font-weight: 600;
    color: #e92504; /* 标签加粗标红 */
  }
}

/* 各功能分区卡片 */
.section-card {
  margin: 0 20px 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;

  .section-title {
    text-align: left;
    font-size: 34px;
    font-weight: 600;
    color: #323233;
  }

  /* 标题行（标题+提示），上传区在其下方（上下结构） */
  .section-header {
    text-align: left;

    .section-title {
      margin: 0;
      display: flex;
      align-items: center; /* 标题与提示文字垂直居中 */
    }
  }

  /* 提示文字：更小更浅 */
  .section-tip {
    font-size: 24px;
    font-weight: 400;
    color: #c8c9cc;
    margin-left: 8px;
  }

  /* 上传区（按钮 + 预览）位于标题下方 */
  .service-uploader {
    margin-top: 24px;

    /* 上传按钮独占一行，位于预览区上方 */
    /deep/ .van-uploader__upload {
      width: 100%;
    }
  }

  /* 蓝色实线边框矩形上传按钮 */
  .upload-btn {
    height: 72px;
    padding: 0 28px;
    font-size: 28px;
    border: 1px solid #e92504;
    border-radius: 12px;
    background: #fff;
    color: #e92504;
  }

  /* 服务说明输入框：灰色细边框 + 圆角 + 内边距，最多500字 */
  .desc-field {
    margin-top: 24px;
    border: 1px solid #ccc;
    border-radius: 16px;
    padding: 20px;
    background: #fff;

    /deep/ .van-field__control {
      font-size: 30px;
      color: #323233;
      line-height: 45px;
    }

    /deep/ .van-field__word-limit {
      font-size: 24px;
      color: #999;
    }
  }
}

/* 底部操作按钮：左侧返回（灰色描边），右侧保存（红色，同报名按钮样式） */
.save-row {
  display: flex;
  margin: 40px 20px 0;

  /* 返回按钮：同 signUp 页取消按钮样式 */
  .btn-cancel {
    flex: 1;
    height: 76px;
    font-size: 30px;
    border-radius: 16px;
    margin-right: 20px;
  }

  .signup-btn {
    flex: 1;
    height: 76px;
    font-size: 30px;
    border-radius: 999px;
    background: #e92504; /* rgb(233, 37, 4) */
    border-color: #e92504;
    color: #fff;
  }
}
</style>
